import React, { useRef, useState, useEffect } from "react";

const useInView = (options = {}) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(entry.target);
      }
    }, { threshold: 0.15, ...options });

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [ref, isVisible];
};

export const ImpactSection = () => {
  const [sectionRef, visible] = useInView();

  return (
    <section id="impact" style={{ background: "#FE3A80" }}>
      {/* Mobile layout */}
      <div className="block lg:hidden px-6 py-16">
        <div className="text-center mb-8">
          <span
            className="inline-block text-[10px] font-medium uppercase tracking-[0.2em] mb-4"
            style={{ fontFamily: "'Inter', Arial, sans-serif", color: "rgba(255,255,255,0.7)" }}
          >
            The Impact
          </span>
          <h2
            className="uppercase leading-[0.85] mb-5"
            style={{
              fontFamily: "'Montserrat', Arial, sans-serif",
              fontWeight: 900,
              fontSize: "1.75rem",
              color: "#ffffff",
            }}
          >
            A Catalyst<br />Moment
          </h2>
        </div>

        <div
          className="relative rounded-2xl overflow-hidden mb-8"
          style={{ aspectRatio: "4/3" }}
        >
          <img
            src="/youth.jpg"
            alt="Youth coming together"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="space-y-4 mb-8 text-center">
          <p
            className="text-lg font-semibold leading-relaxed"
            style={{ fontFamily: "'Inter', Arial, sans-serif", color: "#ffffff" }}
          >
            Teenagers leave with belief and vision.
          </p>
          <p
            className="text-lg font-semibold leading-relaxed"
            style={{ fontFamily: "'Inter', Arial, sans-serif", color: "#ffffff" }}
          >
            Parents leave with hope and pride.
          </p>
        </div>

        <div className="text-center">
        <a
          href="/gallery"
          className="inline-flex items-center justify-center px-8 py-3.5 text-sm font-semibold uppercase no-underline cursor-pointer transition-all duration-300 hover:scale-[1.03] active:scale-[0.98]"
          style={{
            fontFamily: "'Montserrat', Arial, sans-serif",
            letterSpacing: "0.1em",
            background: "#ffffff",
            color: "#FE3A80",
            border: "none",
            borderRadius: "0",
          }}
        >
          View Gallery
        </a>
        </div>
      </div>

      {/* Desktop layout */}
      <div
        ref={sectionRef}
        className="hidden lg:block max-w-[87.5rem] mx-auto px-10 py-[120px]"
      >
        <div className="grid grid-cols-2 gap-16 items-center">
          {/* Image side */}
          <div
            className="relative rounded-2xl overflow-hidden"
            style={{
              aspectRatio: "4/3",
              opacity: visible ? 1 : 0,
              transform: visible ? "translateX(0)" : "translateX(-40px)",
              transition: "opacity 0.8s ease-out, transform 0.8s ease-out",
            }}
          >
            <img
              src="/youth.jpg"
              alt="Youth coming together"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>

          {/* Content side */}
          <div
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? "translateY(0)" : "translateY(40px)",
              transition: "opacity 0.7s ease-out 0.15s, transform 0.7s ease-out 0.15s",
            }}
          >
            <span
              className="inline-block text-xs font-medium uppercase tracking-[0.2em] mb-6"
              style={{ fontFamily: "'Inter', Arial, sans-serif", color: "rgba(255,255,255,0.7)" }}
            >
              The Impact
            </span>
            <h2
              className="uppercase leading-[0.85] mb-8"
              style={{
                fontFamily: "'Montserrat', Arial, sans-serif",
                fontWeight: 900,
                fontSize: "clamp(2rem, 1.5rem + 2vw, 3rem)",
                color: "#ffffff",
              }}
            >
              A Catalyst<br />Moment
            </h2>

            <div className="space-y-5 mb-10">
              <p
                className="text-xl font-semibold leading-relaxed"
                style={{ fontFamily: "'Inter', Arial, sans-serif", color: "#ffffff" }}
              >
                Teenagers leave with belief and vision.
              </p>
              <p
                className="text-xl font-semibold leading-relaxed"
                style={{ fontFamily: "'Inter', Arial, sans-serif", color: "#ffffff" }}
              >
                Parents leave with hope and pride.
              </p>
            </div>

            <div className="pt-8">
              <a
                href="/gallery"
                className="inline-flex items-center justify-center px-8 py-3.5 mt-8 text-sm font-semibold uppercase no-underline cursor-pointer transition-all duration-300 hover:scale-[1.03] active:scale-[0.98]"
                style={{
                  fontFamily: "'Montserrat', Arial, sans-serif",
                  letterSpacing: "0.1em",
                  background: "#ffffff",
                  color: "#FE3A80",
                  border: "none",
                  borderRadius: "0",
                }}
              >
                View Gallery
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
